import React, { useEffect, useRef } from 'react'
import './index.scss';
import { ForgetPasswordInputs, LogInInputs, SignUpInputs } from './inputs';
import Text, { TYPES as types, SIZES as sizes, TextWithIcon } from 'components/elements/Text'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
// import image from 'assets/images/SignInUpBackground.png';
import persosnsImage from 'assets/images/SignInUpBgPersons.png';
import AnimationSignInUp from 'assets/jsons/AnimationSignInUp';
import lottie from "lottie-web";
import animateCard from 'assets/images/animate-card.gif';
import "slick-carousel/slick/slick-theme.css";
import IconNew from 'components/elements/iconsSize'
import { useNavigate } from 'react-router-dom';

//Slider Images
// import image1 from 'assets/images/SignInSlider/Slider1.png'
// import image2 from 'assets/images/SignInSlider/Slider2.png'
// import image3 from 'assets/images/SignInSlider/Slider3.png'
// import image4 from 'assets/images/SignInSlider/Slider4.png'
// import image5 from 'assets/images/SignInSlider/Slider5.png'
// import image6 from 'assets/images/SignInSlider/Slider6.png'
// import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const SignInUpModal = ({ type, onSignUp, onSignin, onForgetPassword, closeModal, onLoadingChange }) => {
    const isRendered = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        if(!isRendered.current) {
            let anim = lottie.loadAnimation({
                container: document.querySelector('#animation_container'),
                animationData: AnimationSignInUp,
                renderer: 'svg',
                loop: true,
                autoplay: true
            });

            isRendered.current = true;
        }
    }, [])

    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true
    };

    const getViewComponent = () => {
        switch (type) {
            case 'login':
                return LogInInputs
            case 'password':
                return ForgetPasswordInputs
            default:
                return SignUpInputs
        }
    }
    const Component = getViewComponent();

    const handleNavigateHome = () => {
        navigate('/');
    }

    return (
        // <GoogleReCaptchaProvider
        //     reCaptchaKey={ process.env.REACT_APP_GOOGLE_RECAPTCHA_V3_SITE_KEY }
        //     scriptProps={{
        //         async: false,
        //         defer: false,
        //         appendTo: "head",
        //         nonce: undefined,
        //     }}
        // >
        <div
            style={{ background: '#fff' }}
            className='flex signin h-[100vh]'
        >
            <div onClick={handleNavigateHome} style={{ position: 'absolute', top: '32px', left: '32px', zIndex: '1', cursor: 'pointer' }}>
                <IconNew  name='MiestroLogo' />
            </div>
            <div className="signin__left  w-1/2 pt-[10px] pb-[20px] px-[77px] flex flex-col gap-3 justify-between items-center">
                <Component
                    // onSignUp={onSignUp}
                    // onSignin={onSignin}
                    // onForgetPassword={onForgetPassword}
                    closeModal={closeModal}
                    onLoadingChange={ onLoadingChange }
                />
                <div className="flex gap-[32px] signin__left__bottom items-center justify-between w-full">
                    <Text
                        inner='Need Help? Contact Support'
                        type={types.regularDefault}
                        size={sizes.small}
                        style={{ color: '#727978' }}
                    />
                    <div className="flex gap-[32px] items-center">
                        <a href="mailto: support@miestro.com">
                            <TextWithIcon
                                iconName='MailContactS'
                                isIconRight={false}
                                inner='support@miestro.com'
                                type={types.regularDefault}
                                size={sizes.small}
                            />
                        </a>
                    </div>
                </div>
            </div>
            <div id='image_wrapper' className="w-1/2 pt-[60px] signin__right flex flex-col gap-5 bg-cover bg-bottom bg-no-repeat items-center justify-end" style={{ backgroundImage: `url(${persosnsImage})` }}>
                <div className="flex flex-col  px-[220px]  items-center gap-4 signin__right__text" id='title_text'>
                    <Text
                        inner='Join The Thousands Of Video Creators Using Miestro'
                        type={types.bold900}
                        style={{ textAlign: 'center', color: "#fff", lineHeight: '150%' }}
                        size={sizes.size_30}
                    />
                </div>
                <div id='animation_container' />
                <div className='h-12'></div>
            </div>
        </div>
        // </GoogleReCaptchaProvider >
    )
}

export default SignInUpModal
